import React from "react";
import { Box } from "@material-ui/core";
import FormattedDate from "components/FormattedDate/FormattedDate";
import SetupCell from "./SetupCell";
import ActionsCell from "./ActionsCell";

const columns = [
    /*{
        Header: () => <input type="checkbox" disabled />,
        accessor: "checked",
        Cell: ({ row }) => <input type="checkbox" checked={row.original.checked} readOnly />,
    },*/
    {
        Header: "Customer Name",
        accessor: "billContact",
    },
    {
        Header: "Dealer Level",
        accessor: "subscriptionName",
    },
    {
        Header: "Domain",
        accessor: "dealerDomain",
    },
    {
        Header: "Nick Name",
        accessor: "company",
    },
    {
        Header: "DLID",
        accessor: "id",
    },
    {
        Header: "Creation Date/Gateways",
        accessor: "createdAt",
        Cell: ({
            row: {
                original: { createdAt },
            },
        }) => (
            <div style={{ textAlign: "center" }}>
                <FormattedDate date={createdAt} />
            </div>
        ),
    },
    /*{
        Header: "",
        accessor: "setup",
        Cell: () => <SetupCell />,
    },*/
    {
        Header: "Actions",
        accessor: "actions",
        Cell: ({ row }) => <ActionsCell row={row} />,
    },
];

export default columns;
